import React from "react";
import {formatFileSize} from "../../../../../utils/utils";
import './fileQueueLine.css'

function FileQueueLine({file, name, extension, downloadSpeed, timeLeft, onDelete, progress}) {
    return (
        <li className="list-group-item" style={{
            overflow: "hidden",
            padding: 0,
        }}>
            <div className="d-flex flex-row col-12 align-items-center" style={{
                paddingLeft: "10px",
                gap: "5px",
            }}>
                <i style={{fontSize: 'x-large'}}
                   className="fa-solid fa-cloud-arrow-up text-muted file-queue-line__file-icon"></i>&nbsp;
                <div className="d-flex flex-column file-queue-line__content">
                    <div style={{fontSize: "small", display: "flex", width: "100%", gap: "5px", alignItems: "center"}}
                         className="drive-contextual__input-name truncated-text file-queue-line__content__title">
                        <div style={{
                            flexShrink: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>
                            {name ?? "Nombre de prueba"}
                        </div>
                        <span className="" style={{
                            flexShrink: 1,
                        }}>.{extension ?? "ext"}</span>
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center mt-1">
                        <div className="d-flex flex-row align-items-center justify-content-end gap-1">
                            {timeLeft != null && <span
                                className="badge rounded-pill bg-secondary file-queue-line__content__download-badge">{timeLeft}s</span>}
                            {downloadSpeed != null && <span
                                className="badge rounded-pill bg-secondary file-queue-line__content__download-badge">{formatFileSize(downloadSpeed)}/s</span>}
                            <span className="badge rounded-pill bg-secondary">{formatFileSize(file?.size)}</span>
                        </div>
                        {onDelete && <span className="ms-1"><i
                            className={"fa-solid fa-trash " + (progress > 0 ? 'text-muted' : 'text-danger')}
                            style={{cursor: "pointer"}}
                            onClick={() => onDelete(file?.name)}></i></span>}
                    </div>
                </div>
            </div>
            <div className="progress file-queue-line__content__progress">
                <div className="progress-bar text-dark" role="progressbar"
                     style={{width: (progress) + '%'}}
                     aria-valuenow={progress}
                     aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
        </li>)
}

export default FileQueueLine;
